/**
 * Compose a patient address into the structure InfoRow expects:
 *   - lines: array of strings, each rendered as its own row line
 *   - copyValue: a single flat string written to the clipboard
 *
 * Mirrors the inline composition in legacy
 * `_legacy/components/InfoPane/Pages/PatientInfo/index.js` so the
 * extracted helper is a 1:1 behavioural replacement.
 */
export const formatAddress = address => {
  if (!address) return { lines: [], copyValue: '' };

  const { streetAddress = '', suite = '', city = '', state = '', zipCode = '' } = address;

  const street = `${streetAddress}${streetAddress && suite ? ' ' : ''}${suite}`;
  const cityState = `${city}${city && state ? ', ' : ''}${state}`;
  const zip = zipCode;

  const lines = [street, cityState, zip].filter(Boolean);

  const copyValue =
    street +
    (street && cityState ? ', ' : '') +
    cityState +
    ((street || cityState) && zip ? ' ' : '') +
    zip;

  return { lines, copyValue };
};
